module.exports = "/packs/media/images/OlderCouple_Kaya-c5651d5705b371bc7a48001c03c6cbec.jpg";